import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography, Button, TextField,
} from '@mui/material';
import { BASE_URL } from "../../App";

const ServiceCallCancellationApproval = () => {
  const [tokens, setTokens] = useState([]);
  const [selectedToken, setSelectedToken] = useState(null);
  const [comments, setComments] = useState('');
  const login_id = localStorage.getItem("LOGIN_ID");

  useEffect(() => {
    fetchTokens();
  }, []);

  const fetchTokens = async () => {
    try {
        
          const res = await axios.post(`${BASE_URL}/index`, {
     
       
            loginId: login_id,
      
      });
      setTokens(res.data);
    } catch (error) {
      console.error('Error loading token data:', error);
      alert('Unauthorized or error fetching data');
    }
  };
  const cancelToken = async () => {
    if (!selectedToken || !comments.trim()) {
      alert("Please select a token and provide a comment before cancelling.");
      return;
    }
  
    try {
      const res = await axios.post(`${BASE_URL}/approve`, {
        token_no: selectedToken,
        comment: comments,
        loginid: login_id,
      });
  
      alert(res.data.message || 'Token cancelled successfully');
      setComments('');
      setSelectedToken(null);
      fetchTokens(); // Refresh the table
    } catch (err) {
      console.error(err);
      alert('Error cancelling token');
    }
  };
  

  return (
    <Paper sx={{ padding: 2 }}>
      <Typography variant="h5" gutterBottom>
        Service Token Cancellation Approval
      </Typography>

      <TableContainer component={Paper} sx={{ marginBottom: 3 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              {[
                'Token No', 'Serial No', 'Item Code', 'Created By', 'Created On', 'Assigned To',
                'Mobile No', 'Customer Details', 'Reason for Cancel', 'Requested By', 'Requested On', 'Action'
              ].map((header) => (
                <TableCell key={header} sx={{ fontWeight: 'bold', backgroundColor: '#e3f2fd' }}>
                  {header}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tokens.map((row) => (
              <TableRow
                key={row.TOKEN_NO}
                hover
                selected={selectedToken === row.TOKEN_NO}
                onClick={() => setSelectedToken(row.TOKEN_NO)}
                sx={{ cursor: 'pointer' }}
              >
                <TableCell>{row.TOKEN_NO}</TableCell>
                <TableCell>{row.SERIALNO}</TableCell>
                <TableCell>{row.ITEMCODE}</TableCell>
                <TableCell>{row.CREATEDBY}</TableCell>
                <TableCell>{row.CREATEDON}</TableCell>
                <TableCell>{row.ASSIGNEDTO}</TableCell>
                <TableCell>{row.MOBILENO}</TableCell>
                <TableCell>{row.CUSTOMERDETAILS}</TableCell>
                <TableCell>{row.REASONFORCANCEL}</TableCell>
                <TableCell>{row.REQUESTEDBY}</TableCell>
                <TableCell>{row.REQUESTEDON}</TableCell>
                <TableCell>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={(e) => {
                      e.stopPropagation();
                      setSelectedToken(row.TOKEN_NO);
                    }}
                  >
                    Approve
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {selectedToken && (
        <>
         <Typography variant="h6" sx={{ mt: 2 }}>
  Selected Token: {selectedToken}
</Typography>

<TextField
  label="Comments"
  multiline
  fullWidth
  rows={3}
  value={comments}
  onChange={(e) => setComments(e.target.value)}
  sx={{ my: 2 }}
/>

<Button
  variant="contained"
  color="error"
  onClick={cancelToken}
>
  Cancel Token
</Button>

        </>
      )}
    </Paper>
  );
};

export default ServiceCallCancellationApproval;
